export default __webpack_public_path__ + "static/media/img14.f5701126.png";